var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 60,
    viewBox: "0 0 160 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 0H0V60H160V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.731 37.813V17.0708H144.74L142.307 20.6608V23.5597H144.74V30.3752V37.813H142.659V43.7217H150.803V37.813H148.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52 16.2876C130.724 16.2876 127.633 20.8215 127.633 26.4458C127.633 32.0222 130.723 36.5734 134.52 36.5734H134.682L132.158 43.7225H136.157L140.19 32.313L140.46 31.5416C141.088 29.9949 141.417 28.236 141.415 26.4458C141.415 20.8221 138.317 16.2876 134.52 16.2876ZM134.519 31.3448C133.84 31.3689 133.17 31.1013 132.597 30.5761C132.023 30.0509 131.572 29.2922 131.301 28.3967C131.029 27.5012 130.95 26.5098 131.073 25.5492C131.195 24.5885 131.515 23.7023 131.99 23.0038C132.465 22.3054 133.075 21.8263 133.741 21.628C134.407 21.4298 135.099 21.5211 135.728 21.8906C136.358 22.26 136.896 22.8908 137.275 23.7021C137.653 24.5134 137.855 25.4685 137.854 26.4452C137.862 27.7289 137.516 28.9651 136.891 29.8834C136.267 30.8016 135.414 31.3271 134.521 31.3448",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4005 2.28564H36.9121V57.7147H45.4005V2.28564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7183 2.28516C5.35304 2.28516 0.189906 9.87524 0.189906 19.2691C0.185526 23.1607 1.09893 26.9396 2.78122 29.9902C1.16476 32.9041 0 36.6588 0 40.748C0 50.1316 5.25868 57.7136 11.6339 57.7136H29.3797V2.28516H11.7183ZM11.7183 14.7569H20.9074V24.0288H11.7183C10.0371 24.0288 8.66229 21.8746 8.66229 19.3924C8.66229 16.9188 10.0371 14.7569 11.7183 14.7569ZM20.9074 45.2349H11.6339C9.93855 45.2349 8.57484 43.0814 8.57484 40.5958C8.57484 38.1102 9.93855 35.952 11.6339 35.952H20.9074V45.2349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.504 57.7146H116.984L108.281 2.28613H91.7685L83.0742 57.7146H91.5483L93.7671 43.5799H106.285L108.504 57.7146ZM95.6759 31.3744L98.2915 14.7565H101.767L104.367 31.3744H95.6759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1228 23.0694C82.1228 11.5849 75.8054 2.28662 67.9991 2.28662H52.9297V57.7134H61.4214V43.5771H68.2097L70.4482 57.7124H78.9099L76.1198 39.9001C77.9908 37.9966 79.5134 35.4721 80.5584 32.5415C81.604 29.611 82.1409 26.3611 82.1234 23.0684L82.1228 23.0694ZM61.4219 14.7549H68.0002C68.7466 14.7512 69.4856 14.964 70.1733 15.3806C70.8609 15.7972 71.483 16.409 72.0019 17.1793C73.0655 18.7582 73.6572 20.8715 73.651 23.0684C73.6628 24.1162 73.5268 25.1564 73.2507 26.1266C72.9746 27.0966 72.5653 27.9763 72.0459 28.7127C71.5169 29.4786 70.8863 30.0844 70.1913 30.4942C69.4963 30.904 68.7517 31.1096 68.0002 31.0988H61.4214L61.4219 14.7549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.999 30.0012H155.94C155.951 25.5562 155.136 21.1876 153.576 17.3477L157.075 14.3901C159.001 19.1265 160.011 24.5162 159.999 30.0012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.577 17.3472C152.587 14.9225 151.303 12.7718 149.785 10.9969L152.348 6.47461C154.24 8.68671 155.841 11.3673 157.075 14.3897L153.577 17.3472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.784 10.9975C146.895 7.61971 143.278 5.79256 139.554 5.83013C137.92 5.82516 136.295 6.16964 134.731 6.85227L133.543 1.27722C135.491 0.425359 137.517 -0.00522847 139.553 -0.000389162C144.212 -0.0431172 148.735 2.24641 152.346 6.4746L149.784 10.9975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.387 9.85793L128.094 5.04723C129.767 3.40108 131.604 2.12991 133.543 1.27734L134.731 6.85241C133.185 7.53218 131.721 8.54563 130.387 9.85793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.576 17.2567L122.086 14.2774C123.602 10.6133 125.653 7.46417 128.098 5.04639L130.39 9.85711C128.432 11.7955 126.79 14.3199 125.576 17.2567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.173 30.0004H119.113C119.102 24.4711 120.128 19.0396 122.085 14.2778L125.574 17.2584C123.991 21.1185 123.161 25.5203 123.173 30.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.558 60.0003C128.094 60.0003 119.113 46.8229 119.113 30.0005H123.173C123.173 43.5536 130.37 54.1698 139.558 54.1698C148.746 54.1698 155.942 43.5536 155.942 30.0005H160.001C160.001 46.8229 151.021 60.0003 139.558 60.0003Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner5);
export default __webpack_public_path__ + "static/media/Partner5.c19b2a54721e755d758fa2c703767b9f.svg";
export { ForwardRef as ReactComponent };